import { Avatar } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';

const EditBy = ({ name, avatar, updated, t }) => {
  return (
    <div className="edit-by">
      <Avatar size="xs" image={avatar} />
      <span className="edit-by__editby">{updated ? t('course:Edit by') : t('course:Created by')}</span>
      <span className="edit-by__editby-name">{name}</span>
    </div>
  );
};

export default EditBy;

EditBy.propTypes = {
  name: PropTypes.string,
  avatar: PropTypes.string,
  updated: PropTypes.bool,
  t: PropTypes.func,
};

EditBy.defaultProps = {
  name: '',
  avatar: '',
  updated: false,
};
